import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import Legal from "../Forms/E/Legal/Legal"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const LegalContainer = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, loadCollection, handleLoadPrev } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingLegal, setIsGettingLegal] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingLegal(true)
      handleSubmitGet(endpoints.GET_LEGAL_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
        organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.LEGAL,
      })
        .then((response) => {
          loadCollection(setValues(response.data), INTERVIEW_SECTIONS.LEGAL)
          handleLoadPrev(false)
          setIsGettingLegal(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingLegal(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const setValues = (data) => {
    return {
      gpra_e_1: data?.form?.gpraE1 ?? "",
      gpra_e_1_num: data?.form?.gpraE1Num ?? 0,
      gpra_e_2: data?.form?.gpraE2 ?? "",
      gpra_e_3: data?.form?.gpraE3 ?? "",
      gpra_e_4: data?.form?.gpraE4 ?? "",
      gpra_e_id: data?.form?.gpraEId ?? 0,
      additional: data?.additional,
    }
  }
  if (isGettingLegal) {
    ;<LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingLegal && (
        <Legal showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default LegalContainer
